import React, { useEffect } from 'react'
import { useAppSelector } from 'src/hooks'
import { selectUser } from 'src/redux'
import useWebSocket from 'react-use-websocket'
import { useToastContext } from 'src/contexts/Toast.context'
import { Box, Typography } from '@mui/material'

const useWebsocketNotification = () => {
  const { serverUrl: serverPath, userName } = useAppSelector(selectUser)
  const { warning } = useToastContext()
  const WS_URL =
    'wss://' +
    serverPath +
    '/sialdPMS/secure/logged/panel/layout/mainLayout?' +
    userName

  const { lastJsonMessage } = useWebSocket<any>(WS_URL, {
    share: false,
    shouldReconnect: () => true
  })

  useEffect(() => {
    const messageTitle = lastJsonMessage?.title
    const messageBody = lastJsonMessage?.message
    if (messageTitle || messageBody) {
      warning({
        message: (
          <Box>
            {messageTitle && (
              <Typography fontWeight={600}>{messageTitle}</Typography>
            )}
            <Typography>{messageBody}</Typography>
          </Box>
        ),
        options: {
          autoClose: false
        }
      })
    }
  }, [lastJsonMessage])

  return {}
}

export default useWebsocketNotification
